import React from "react";

const ContactInfo = () => (
  <ul className="contact">
    <li className="fa-envelope">
      <a href="mailto:info@ewwoconsulting.com">info@ewwoconsulting.com</a>
    </li>
    <li className="fa-linkedin">
      <a href="https://ar.linkedin.com/company/ewwo-consulting">
        Ewwo Consulting
      </a>
    </li>
    <li className="fa-phone">AR + 54 011 5199 4390</li>
    <li className="fa-phone">US + 1 315 245 8141</li>
  </ul>
);

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/ContactInfo.js